export default __webpack_public_path__ + "static/media/logo-dash-header.98966b04.png";